import React, {useContext, useEffect, useState} from "react";
import SnackbarContext from "../../providers/snackbar-context";
import {Box, Text} from "@nike/eds";
import {FlowSearchResults} from "./FlowSearchResults";
import {FlowSearchForm} from "./FlowSearchForm";
import {FlowSearchModel} from "../../model/FlowSearchModel";
import {edsSpace16} from "@nike/eds/dist/tokens";
import useSWR from "swr";

export function FlowSearchOverview({structuredLogsService, permissions, LocationTracker}: {
    structuredLogsService: any,
    permissions: any,
    LocationTracker: any
}) {

    const snackbarCtx = useContext(SnackbarContext);
    const [currentSearchForm, setCurrentSearchForm] = useState({});

    const fetcher = async (flowSearchModel: FlowSearchModel) => {
        console.log("Fetching with search model:", flowSearchModel); // Debug to verify trigger list is included
        return await structuredLogsService.listFlows(
            flowSearchModel.typeList,
            flowSearchModel.statusList,
            flowSearchModel.startDate,
            flowSearchModel.endDate,
            flowSearchModel.businessReference,
            flowSearchModel.flowId,
            flowSearchModel.detailList,
            flowSearchModel.shippingPointList,
            flowSearchModel.inventoryLocationList,
            flowSearchModel.triggerList,
            permissions
        );
    };

    const {isLoading, data, error} = useSWR(currentSearchForm, fetcher, {
        refreshInterval: 15000
    });
    console.log("Search result state: ", isLoading, data, error);

    let errorMessage = "";
    if (error && !isLoading) {
        errorMessage = error.message;
    }
    useEffect(() => {
        if (errorMessage && errorMessage !== "") {
            snackbarCtx.displayMsg(errorMessage, "error");
        }
    }, [errorMessage, snackbarCtx]);

    let searchResults = [];
    if (!isLoading && data) {
        searchResults = data.data.listFlowsDynamicSearch.items;
    }

    const searchHandler = (flowSearchModel: FlowSearchModel) => {
        console.log("Search handler received model:", flowSearchModel); // Debug logging
        setCurrentSearchForm(flowSearchModel);
    }

    const titleStyle = {
        marginBottom: edsSpace16
    }

    return (
        <div>
            <LocationTracker location="Flow overview" sublocation="Search"
                        {...currentSearchForm} />
            <Text style={titleStyle} font={"display-3"} as={"h3"}>EVENTS</Text>

            <Box className="nesg-grid nesg-grid-md-cols-2 nesg-grid-items-center">
                <FlowSearchForm onSearch={searchHandler} permissions={permissions}/>
                <div></div>
                <FlowSearchResults searchResults={searchResults} loading={isLoading}/>
            </Box>
        </div>
    )
}
